import type { SVGProps } from "react";
import { Ref, forwardRef, memo } from "react";
const SvgMdiCellphone = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    ref={ref}
    {...props}
  >
    <path
      fill="currentColor"
      d="M17 19H7V5h10m0-4H7c-1.11 0-2 .89-2 2v18a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgMdiCellphone);
const Memo = memo(ForwardRef);
export default Memo;
